










import NuxtFooter from 'library/components/layout/footer/footer'
import inViewportMixin from 'vue-in-viewport-mixin'

export default

	mixins: [inViewportMixin]

	data: -> hasRendered: false

	components: { NuxtFooter }

	computed:

		# Render depdendencies
		loaded: -> !!@$store.state.globals.footerNavigation
		secondaryContentRendered: -> @$store.state.pdp.secondaryContentRendered

		# Render the footer after the secondary content is rendered so we don't
		# mount it early just because the secondary content has 0 height, forcing
		# the footer higher up the page
		canRender: ->
			if @hasRendered then true
			else @loaded and @inViewport.now and @secondaryContentRendered

	watch:

		# Prevent the footer from unrendering when the user scrolls up
		canRender: -> @hasRendered = true


